import { IApiServer } from "../../ChoiceScreens/Admin/IApiServer";
import { IBustCacheResults } from "../../ChoiceScreens/Admin/IBustCacheResults";
import { ICacheStatistics } from "../../ChoiceScreens/Admin/ICacheStatistics";
import { getObject, getText } from "../ChoiceApi";

export const CacheService = {
    GetStatistics,
    BustCacheType,
    GetCacheTokens,
    GetApiServers,
    GetStatisticsRemote,
    GetCurrentApiServer
}

export async function GetStatistics(): Promise<ICacheStatistics | undefined>
{
    return await getObject<ICacheStatistics>('api/Admin/GetCacheStats'); 
}

export async function GetStatisticsRemote(hostName: string): Promise<ICacheStatistics | undefined>
{
    return await getObject<ICacheStatistics>(`https://${hostName}/officemd/api/Admin/GetCacheStats`); 
}

export async function BustCacheType(allServers:boolean, allTypes:boolean, type:string | number): Promise<IBustCacheResults[] | undefined>
{
    return await getObject<IBustCacheResults[]>(`api/Admin/BustCacheType/${allServers}/${allTypes}/${type}`); 
}

export async function GetApiServers(): Promise<IApiServer[] | undefined>
{
    return await getObject<IApiServer[]>(`api/Admin/GetApiServers`); 
}

export async function GetCurrentApiServer(): Promise<IApiServer | undefined>
{
    return await getObject<IApiServer>('api/Admin/GetCurrentApiServer'); 
}

export async function GetCacheTokens(): Promise<string[] | undefined>
{
    return await getObject<string[]>('`api/Admin/GetCacheTokens'); 
}



